import { Rectangle } from 'pixi.js';
import Core from '../../../../Core/Core';
import { ICollectablesData } from '../../../../State/reducers/player';
import { Collection } from '../../../../Tiles/TileSet';
import { createOutlineText } from '../../../../Utils/Utils';
import { PopupPage } from '../../../Shared/PopupPage';
import { CollectablesRadioGroup } from './CollectablesRadioGroup';

export class CollectablesPage extends PopupPage {
    private readonly collectablesRadioGroup: CollectablesRadioGroup;

    constructor(
        bgTab: PIXI.mesh.NineSlicePlane,
        collectablesProgress: ICollectablesData,
        selectedCollection: Collection
    ) {
        super();
        const { width, height } = bgTab;
        const glow = new PIXI.Sprite(PIXI.utils.TextureCache['commonui/opt-in_icon_rays']);
        glow.anchor.set(0.5);
        glow.scale.set(0.7);
        glow.x = width * 0.15;
        glow.y = -height * 0.2;

        const icon = new PIXI.Sprite(PIXI.utils.TextureCache['mapui/scrapbook-tles-icon']);
        icon.anchor.set(0.5);
        icon.x = glow.x;
        icon.y = glow.y;

        const disclamer = createOutlineText(
            Core.local.getText('CollectTokens'),
            new Rectangle(0, 0, width * 0.7, height * 0.2),
            'Baloo',
            28,
            30,
            0xffffff,
            0x006073
        );
        disclamer.anchor.set(0.5);
        disclamer.x = width * 0.6;
        disclamer.y = -height * 0.2;

        this.collectablesRadioGroup = new CollectablesRadioGroup(
            bgTab,
            collectablesProgress,
            selectedCollection
        );

        //@ts-ignore
        this.addChild(glow, icon, disclamer, this.collectablesRadioGroup);
    }
}
